import { createFileRoute } from "@tanstack/react-router";
import { ConsentForm } from "@/components/site/ConsentForm";
import { SiteFooter } from "@/components/site/SiteFooter";
import { SiteHeader } from "@/components/site/SiteHeader";
import { TERMS_DATE, TERMS_SECTIONS, TERMS_VERSION } from "@/lib/terms";

export const Route = createFileRoute("/terms")({
  head: () => ({
    meta: [
      { title: "General Terms and Conditions | Bauer IP Patent Attorney" },
      {
        name: "description",
        content:
          "General Terms and Conditions for the provision of patent attorney services by Karel Bauer, European and Czech Patent and Trademark Attorney, plus the client consent form.",
      },
      { property: "og:title", content: "General Terms and Conditions | Bauer IP" },
      { property: "og:image", content: "https://bauerip.com/og-us.jpg" },
      { name: "twitter:image", content: "https://bauerip.com/og-us.jpg" },
      {
        property: "og:description",
        content:
          "Terms governing patent and trade mark attorney services before the EPO, EUIPO and the Czech Industrial Property Office, with an online client consent form.",
      },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://bauerip.com/terms" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://bauerip.com/terms" }],
  }),
  component: TermsPage,
});

function TermsPage() {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <SiteHeader />
      <main className="flex-1">
        <section className="mx-auto max-w-3xl px-6 pb-10 pt-14 md:pt-18">
          <p className="eyebrow mb-4">Legal</p>
          <h1 className="font-serif text-4xl leading-tight text-foreground md:text-5xl">
            General Terms and Conditions
          </h1>
          <p className="mt-5 text-lg leading-relaxed text-muted-foreground">
            For the provision of patent attorney services by Mgr. Karel Bauer, European and Czech
            Patent and Trademark Attorney.
          </p>
          <div className="mt-6 rounded-lg border border-border bg-secondary/30 p-5 text-sm leading-relaxed text-muted-foreground">
            <p className="text-foreground">Mgr. Karel Bauer</p>
            <p>European and Czech Patent and Trademark Attorney</p>
            <p>Registered office: Urešova 1266/2, 148 00 Prague 4, Czech Republic</p>
            <p>ID No.: 078 91 032</p>
            <p className="mt-2">
              Version {TERMS_VERSION} · effective {TERMS_DATE}
            </p>
          </div>
        </section>

        <section className="mx-auto max-w-3xl px-6 pb-14">
          <ol className="space-y-9">
            {TERMS_SECTIONS.map((section, index) => (
              <li key={section.heading}>
                <h2 className="font-serif text-2xl text-foreground">
                  {index + 1}. {section.heading}
                </h2>
                <div className="mt-3 space-y-3">
                  {section.paragraphs.map((paragraph) => (
                    <p className="text-sm leading-relaxed text-muted-foreground" key={paragraph.slice(0, 40)}>
                      {paragraph}
                    </p>
                  ))}
                </div>
              </li>
            ))}
          </ol>
        </section>

        <section className="mx-auto max-w-3xl px-6 pb-20" id="consent">
          <ConsentForm />
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}
